import { AxiosError } from 'axios';
import { put, call, select, takeLatest } from 'redux-saga/effects';
import { selectors as clientSelectors } from 'store/clients';
import { API } from 'services/api/base';
import { getErrorCode } from 'services/api/normalizer';
import { types, GetDeliveryLogRequest, GetDeliveryLogResponse } from './types';

export function* getDeliveryLogAsync({ payload }: GetDeliveryLogRequest) {
  const { page, startTime, endTime, exportData = false, ...otherParams } = payload;
  yield put({ type: types.GET_DELIVERY_LOG.PENDING, payload: { pending: true, exportData } });

  try {
    const clientId: string = yield select(clientSelectors.selectClientId);

    let currentDate;
    let lastDate;
    if (startTime === null) {
      currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 90);
      currentDate = currentDate.toISOString();
    }
    if (endTime === null) {
      lastDate = new Date().toISOString();
    }

    const api = new API(`clients/${clientId}/deliveryLog?page=${page}`);
    const response: GetDeliveryLogResponse = yield call(api.create, {
      ...otherParams,
      startTime: startTime ? startTime : currentDate,
      endTime: endTime ? endTime : lastDate,
      limit: exportData ? null : '100'
    });

    if (!exportData && (page === 1 || page === undefined)) {
      yield put({ type: types.RESET_DELIVERY_LOG });
    }

    yield put({ type: types.GET_DELIVERY_LOG.SUCCESS, payload: { ...response, exportData } });
  } catch (err) {
    const errorCode = getErrorCode(err as AxiosError) as number;

    if (errorCode >= 400 && errorCode < 500) {
      yield put({ type: types.GET_DELIVERY_LOG.ERROR, payload: 'Invalid credentials' });
    } else if (errorCode >= 500) {
      yield put({ type: types.GET_DELIVERY_LOG.ERROR, payload: 'Server error' });
    } else {
      yield put({ type: types.GET_DELIVERY_LOG.ERROR, payload: 'Uh oh! Something went wrong. Please try again.' });
    }
  } finally {
    yield put({ type: types.GET_DELIVERY_LOG.PENDING, payload: { pending: false, exportData } });
  }
}

export const sagas = [takeLatest(types.GET_DELIVERY_LOG.REQUEST, getDeliveryLogAsync)];
